exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".choosepeople{height:100%;width:100%;overflow:auto}.choosepeople::-webkit-scrollbar-track{background-color:#f5f5f5;-webkit-box-shadow:inset 0 0 6px rgba(0,0,0,.22)}.choosepeople::-webkit-scrollbar{display:block;width:7px;background-color:hsla(220,4%,58%,.3)}.choosepeople::-webkit-scrollbar-thumb{background-color:#8b8b8b;border-radius:7px}@media (max-width:750px){.choosepeople{width:100%;height:100%}}.choosepeople .el-tree>.el-tree-node>.el-tree-node__content>.el-checkbox{display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-629dab76","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/packages/selectuser/um-selectuser.vue
// module id = 56
// module chunks = 0